import { render, staticRenderFns } from "./select_client_company.vue?vue&type=template&id=7640673d&scoped=true&"
import script from "./select_client_company.vue?vue&type=script&lang=js&"
export * from "./select_client_company.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7640673d",
  null
  
)

export default component.exports